<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { onMounted, ref } from 'vue';
import { RouterLink } from 'vue-router';
import Auth from 'dashboard/api/auth';
import { useAccount } from 'dashboard/composables/useAccount';
import { useTracking } from 'dashboard/composables';
import { trackQuintoEvent } from 'dashboard/helper/lais/trackingEvents';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisHeader from 'dashboard/components-next/LaisHeader.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

const account = useAccount();
const { track } = useTracking();
const isSubmitting = ref(false);
const hasFailed = ref(false);

const performLogout = async () => {
  hasFailed.value = false;
  isSubmitting.value = true;

  try {
    trackQuintoEvent(track, 'logout_pwa', {
      domain: 'auth',
      entry_point: 'logout_page',
    });
    await Auth.logout();
    window.setTimeout(() => {
      if (window.location.pathname.endsWith('/logout')) {
        window.location.assign('/app/login');
      }
    }, 1500);
  } catch {
    hasFailed.value = true;
    isSubmitting.value = false;
  }
};

onMounted(() => {
  performLogout();
});
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <section class="flex h-full flex-col overflow-hidden bg-[#fcfaf6]">
    <LaisHeader
      title="Encerrando sessão"
      helper="Estamos finalizando sua sessão na Imudei e limpando os dados locais do navegador."
    />

    <div class="flex flex-1 items-center justify-center px-4 py-8 sm:px-6">
      <LaisCard title="Saída segura" class="w-full max-w-[560px]">
        <div class="space-y-4 text-[13px] leading-6 text-lais-text-muted">
          <p v-if="!hasFailed">
            Seu logout está em andamento. Se o redirecionamento não acontecer em
            instantes, você pode voltar manualmente para a tela de login.
          </p>
          <p v-else>
            Não conseguimos encerrar sua sessão automaticamente. Você pode
            tentar novamente ou voltar ao login.
          </p>

          <div class="flex flex-wrap gap-2">
            <LaisPrimaryButton
              icon="i-lucide-loader-circle"
              :is-loading="isSubmitting"
              @click="performLogout"
            >
              Tentar novamente
            </LaisPrimaryButton>

            <RouterLink
              :to="account.accountScopedRoute('meus_dados_index')"
              class="inline-flex items-center gap-2 rounded-lais border border-lais-border bg-white px-4 py-2.5 text-[14px] font-semibold text-lais-text transition-all hover:border-lais-primary hover:text-lais-link"
            >
              Voltar para meus dados
            </RouterLink>

            <a
              href="/app/login"
              class="inline-flex items-center gap-2 rounded-lais border border-lais-border bg-white px-4 py-2.5 text-[14px] font-semibold text-lais-text transition-all hover:border-lais-primary hover:text-lais-link"
            >
              Ir para login
            </a>
          </div>
        </div>
      </LaisCard>
    </div>
  </section>
</template>
